import { useArticleMeta } from 'hooks/useArticleMeta'
import { useCurrentArticleId } from 'hooks/useCurrentArticleId'
import { ArticleFlat } from 'types'
import dayjs from 'dayjs'
import Styles from '../MoreOptionsDropdown.module.scss'

export const LastEditedByInlineFormatItem = () => {
  const currentArticleId = useCurrentArticleId()
  const article = useArticleMeta(currentArticleId) as ArticleFlat
  const lastEditedAt = article?.last_edited_at
  const lastEditedBy = article?.last_edited_by

  return (
    <div className={Styles.lastEdited}>
      <div className={Styles.name}>Last edited by {lastEditedBy}</div>
      <div>{dayjs(lastEditedAt).format('MMM DD YYYY h:mm A')}</div>
    </div>
  )
}
